import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.25 3A.75.75 0 0 1 3 2.25h18a.75.75 0 0 1 .75.75v18a.75.75 0 0 1-.75.75H3a.75.75 0 0 1-.75-.75zm1.5 6.75v4.5h7.5v-4.5zm9 0v4.5h7.5v-4.5zm7.5-1.5h-7.5v-4.5h7.5zm-9-4.5v4.5h-7.5v-4.5zm9 12h-7.5v4.5h7.5zm-9 4.5v-4.5h-7.5v4.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }